import { useSelector, shallowEqual } from "react-redux";
import ProductRating from "app/pages/FicheProduit/components/ProductRating/ProductRating";
import { getSDPProductsRating } from "app/pages/SmartDP/Listing/SmartDPFilters/smartDPProductsFilterSelectors";

const mapStateToProps = state => ({
	ratingType: getSDPProductsRating(state),
});

const ProductRatingContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <ProductRating {...props} {...stateProps} />;
};

export default ProductRatingContainer;
